import { copyObj } from "core/iterable_utils";

const filterNestedTableRow = ({ tableData, filterCallback, itemModelName, generalRowCallback }) => {
	const filterRow = ({ row }) => {
		if (row.model_name === itemModelName) {
			if (!filterCallback({ row })) {
				row.visible = false;
			} else {
				row.visible = true;
			}
		}

		if ("_children" in row) {
			const children = row._children;
			children.forEach((childRow) => {
				filterRow({ row: childRow });
			});
			if (!children.some((childRow) => childRow.visible) && row.model_name !== itemModelName) {
				row.visible = false;
			}
		}

		if (generalRowCallback != null) generalRowCallback({ row });
		return row;
	};

	const newTableData = copyObj(tableData).map((row) => filterRow({ row }));

	return newTableData;
};

const applyLsrTableDataFilter = ({ state }) => {
	if (state.selectedLsrViewMode.attr === "ALL") {
		state.filtredLsrTableData = state.lsrTableData;
	} else if (state.selectedLsrViewMode.attr === "ONLY_FREE") {
		state.filtredLsrTableData = filterNestedTableRow({
			tableData: state.lsrTableData,
			itemModelName: "LocalEstimatesItems",
			filterCallback: ({ row }) => {
				return row.has_vor_link === false;
			},
		});
	} else if (state.selectedLsrViewMode.attr === "ONLY_CONNECTED") {
		state.filtredLsrTableData = filterNestedTableRow({
			tableData: state.lsrTableData,
			itemModelName: "LocalEstimatesItems",
			filterCallback: ({ row }) => {
				return row.has_vor_link === true;
			},
		});
	} else if (state.selectedLsrViewMode.attr === "CONNECTED_WITH_SELECTED_VOR_ITEM") {
		if (state.selectedVorItem?.num) {
			state.filtredLsrTableData = filterNestedTableRow({
				tableData: state.lsrTableData,
				itemModelName: "LocalEstimatesItems",
				filterCallback: ({ row }) => {
					return (
						row?.vor_link_item_num &&
						row?.vor_link_item_num?.includes(state.selectedVorItem.num) &&
						row?.vor_link_file_name === state.selectedVor?.file_name
					);
				},
			});
		} else {
			state.filtredLsrTableData = [];
		}
	} else {
		state.filtredLsrTableData = [];
	}
};

const generalVorRowVisibleCallback = ({ state, row }) => {
	if (row.model_name === "VorResource") {
		if (state.displayOptions.showVorTableResource != null) {
			row.visible = state.displayOptions.showVorTableResource;
		}
	}
};

const applyVorTableDataFilter = ({ state }) => {
	if (state.selectedVorViewMode.attr === "ALL") {
		state.filtredVorTableData = filterNestedTableRow({
			tableData: state.vorTableData,
			itemModelName: "VorWork",
			filterCallback: ({ row }) => true,
			generalRowCallback: ({ row }) => generalVorRowVisibleCallback({ state, row }),
		});
	} else if (state.selectedVorViewMode.attr === "ONLY_FREE") {
		state.filtredVorTableData = filterNestedTableRow({
			tableData: state.vorTableData,
			itemModelName: "VorWork",
			filterCallback: ({ row }) => {
				return row.some_lsr_item_is_connected === false;
			},
			generalRowCallback: ({ row }) => generalVorRowVisibleCallback({ state, row }),
		});
	} else if (state.selectedVorViewMode.attr === "ONLY_CONNECTED") {
		state.filtredVorTableData = filterNestedTableRow({
			tableData: state.vorTableData,
			itemModelName: "VorWork",
			filterCallback: ({ row }) => {
				return row.some_lsr_item_is_connected === true;
			},
			generalRowCallback: ({ row }) => generalVorRowVisibleCallback({ state, row }),
		});
	} else if (state.selectedVorViewMode.attr === "CONNECTED_WITH_SELECTED_LSR_ITEM") {
		if (state.selectedLsrItem?.vor_link_file_name === state.selectedVor?.file_name) {
			state.filtredVorTableData = filterNestedTableRow({
				tableData: state.vorTableData,
				itemModelName: "VorWork",
				filterCallback: ({ row }) => {
					return state.selectedLsrItem?.vor_link_item_num?.includes(row.num);
				},
				generalRowCallback: ({ row }) => generalVorRowVisibleCallback({ state, row }),
			});
		} else {
			state.filtredVorTableData = [];
		}
	} else {
		state.filtredVorTableData = [];
	}
};

export { applyLsrTableDataFilter, applyVorTableDataFilter };
